import { api } from './client';

export type HabitPeriod = 'DAY' | 'WEEK' | 'MONTH';
export type Polarity = 'POSITIVE' | 'NEGATIVE';

export interface Habit {
  id: string;
  name: string;
  icon: string | null;
  polarity: Polarity;
  tracksValue: boolean;
  valuePrompt: string | null;
  unit: string | null;
  period: HabitPeriod;
  targetCount: number;
  expectedDays: string | null;
  startDate: string;
  active: boolean;
  position: number;
  currentStreak: number;
  longestStreak: number;
  satisfied: number;
  applicable: number;
  rate: number;
  currentPeriodKey: string;
  currentPeriodSatisfied: boolean;
  currentPeriodCount: number;
}

export interface HabitLog {
  id: string;
  habitId: string;
  onDate: string;
  occurred: boolean;
  amount: number | null;
  note: string | null;
  source: string;
  checkinId: string | null;
  loggedAt: string;
}

/** A period already judged by the server, so the client draws rather than decides. */
export interface HabitPeriodCell {
  key: string;
  start: string;
  end: string;
  successes: number;
  satisfied: boolean;
  open: boolean;
  applicable: boolean;
}

export function getHabits(): Promise<Habit[]> {
  return api<Habit[]>('/habits');
}

export function createHabit(body: {
  name: string;
  polarity?: Polarity;
  period?: HabitPeriod;
  targetCount?: number;
  expectedDays?: string | null;
  tracksValue?: boolean;
  valuePrompt?: string | null;
  unit?: string | null;
}): Promise<Habit> {
  return api<Habit>('/habits', { method: 'POST', body });
}

export function updateHabit(id: string, body: { active?: boolean; name?: string }): Promise<Habit> {
  return api<Habit>(`/habits/${id}`, { method: 'PATCH', body });
}

export function logHabit(
  id: string,
  body: { onDate: string; occurred: boolean; amount?: number | null; note?: string | null }
): Promise<HabitLog> {
  return api<HabitLog>(`/habits/${id}/logs`, { method: 'POST', body: { ...body, source: 'web' } });
}

export function getHabitLogs(id: string, from?: string): Promise<HabitLog[]> {
  return api<HabitLog[]>(`/habits/${id}/logs`, { query: { from } });
}

export function getHabitCalendar(id: string, from?: string): Promise<HabitPeriodCell[]> {
  return api<HabitPeriodCell[]>(`/habits/${id}/calendar`, { query: { from } });
}
